import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueCookies from 'vue-cookies'
createApp(App).use(i18n).use(store).use(router).use(VueCookies).mount('#app')